// INSTANCE
export const INSTANCE_REQUEST = 'INSTANCE_REQUEST';
export const INSTANCE_SUCCESS = 'INSTANCE_SUCCESS';
export const INSTANCE_ERROR = 'INSTANCE_ERROR';
export const CLEAR_INSTANCE = 'CLEAR_INSTANCE';

// VERSION
export const VERSION_SUCCESS = 'VERSION_SUCCESS';
